import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useNavigationMenu } from "hooks/useNavigationMenu";
import { SubMenuOption } from "../SubMenuOption";
import { useDispatch } from "react-redux";
import { Navigation } from "interfaces";
import { useAppSelector } from "hooks";
import { isSaleActive } from "./helper";
import {
	selectPoisBountyV3State,
	selectStickySaleTagState,
	setOpen
} from "redux/slices";

interface Props {
	categoryId: number;
}

export const SubMenu: React.FC<Props> = ({ categoryId }) => {
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { userTracker } = useWebStoreContext();
	const { saleTags } = useAppSelector(selectStickySaleTagState);
	const { eventActive: isPoisActive } = useAppSelector(selectPoisBountyV3State);
	const dispatch = useDispatch();
	const navigation = useNavigationMenu(
		userTracker?.clubId,
		isPoisActive,
		userTracker
	);

	const reportToGoogle = (analytics_key: string, sale_tag = false) => {
		reportEvent(analytics_key, {
			source: "mega_menu",
			sale_tag: sale_tag
		});
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: analytics_key,
			event_type: "mega_menu",
			action: analytics_key,
			source: "mega_menu",
			tag_type: sale_tag
		});
	};

	const handleClick = (page: Navigation) => {
		window.scrollTo(0, 0);
		dispatch(setOpen(false));
		const sale_actived = isSaleActive(saleTags, page.title);
		reportToGoogle(page.analytics_key, sale_actived);
	};

	return (
		<>
			{navigation
				.filter((n) => n.categoryId === categoryId)
				.map((page) => {
					if (!page.isEnabled) {
						return null;
					}
					if (page.isExternal) {
						return (
							<Link
								href={page.path}
								style={{ textDecoration: "none" }}
								key={page.path}
								target="_blank"
								onClick={() => reportToGoogle(page.analytics_key)}
							>
								<SubMenuOption page={page} />
							</Link>
						);
					}

					return (
						<RouterLink
							to={page.path}
							style={{ textDecoration: "none" }}
							key={page.path}
							onClick={() => handleClick(page)}
						>
							<SubMenuOption page={page} />
						</RouterLink>
					);
				})}
		</>
	);
};
